import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from '../../auth/services/auth.service';
import { LoadingStateService } from '@net3-multiplatform-client/libs';

export const authGuard = (redirectUrl: string): CanActivateFn => 
  () => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const loadingService = inject(LoadingStateService)
    
    loadingService.showLoadingPage.set(true);
    return authService.getValidJwt$().pipe(
      map(jwt => {
        if (!jwt || authService.isExpired(jwt)) {
          return router.createUrlTree(
            [redirectUrl],
          );
        }
        return true;
      }),
      catchError((e) => {
        //console.log(e);
        return of(router.createUrlTree(
          [redirectUrl],
        ))
      })
    )
  };